/**
 * Identify the document reference according to platforms and expose the same
 */

const Document = typeof document === "undefined" ? window.document : document;

export default Document;
